import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import { toast } from "react-toastify";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import DeliveryModal from "@/app/core/layouts/main-components/delivery/DeliveryModal";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import OnDataChange from "@/app/core/util/helpers/HandleChange";

export default function TrackingComponent() {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [deliveryId, setDeliveryId] = useState(null);
    const [results, setResults] = useState([]);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => { }, []);

    function handleChange(evt) {
        setData(OnDataChange(data, evt));
    }

    function goSearch(e) {
        e.preventDefault();
        if (!data.query) {
            toast.error(Message.PendingData);
        } else {
            DeliveryController.Search(data.query, userData.id, res => setResults(res));
        }
    }

    function openDelivery(item) {
        setDeliveryId(item.id);
        setShowModal(true);
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Tracking)}</h3>
            </div>
            <div className="form-group col-md-12 block block-fx-pop block-rounded">
                <form onSubmit={e => goSearch(e)}>
                    <div className="block-content">
                        <div className="form-group">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Pesquisar entrega..." name="query" value={data && data.query} onChange={evt => handleChange(evt)} />
                                <div className="input-group-append" onClick={() => goSearch()}>
                                    <span className="input-group-text">
                                        <i className="fa fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="col-12">
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>{Translate(Message.DeliveryCode)}</th>
                            <th>{Translate(Message.Origin)}</th>
                            <th>{Translate(Message.Destination)}</th>
                            <th>Status</th>
                            <th>{Translate(Message.RequestDate)}</th>
                            {/* <th>{Translate(Message.Delivery.Delivery)}</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {results && results.map(item => (
                            <tr>
                                <td>{item.id}</td>
                                <td>
                                    <span>
                                        <b>{item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood}`}</b>
                                        <br />
                                        <small>{item && item.origin && `${item.origin.city} - ${item.origin.state}`}</small>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        <b>{item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood}`}</b>
                                        <br />
                                        <small>{item && item.destination && `${item.destination.city} - ${item.destination.state}`}</small>
                                    </span>
                                </td>
                                <td>{DeliveryHelper().Status(item.status)}</td>
                                <td>{DateTranslate(item.createdAt)}</td>
                                <td>
                                    <button className="btn btn-dual" onClick={() => openDelivery(item)}><i className="fa fa-eye" /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <DeliveryModal
                show={showModal}
                deliveryId={deliveryId}
                onHide={() => setShowModal(false)}
            />
        </div>
    )
}